import { Accordion } from '@mantine/core';

import { ExpandDown } from '@/new_src/view/assets/new_icons/ExpandDown';

import { mantineColors } from '@/theme/mantineColors';

export const AccordionResolver = Accordion.extend({
  defaultProps: {
    chevron: <ExpandDown />,
  },
  styles: () => ({
    control: {
      padding: 0,
      boxSizing: 'border-box',
    },
    content: {
      padding: 0,
    },

    icon: {
      width: 12,
      height: 12,
    },
    item: {
      borderBottom: 'none',
    },
    chevron: {
      path: {
        stroke: mantineColors.gray[6],
      },
    },
  }),
});
